import {
  CtaWireframeButton,
  Heading3,
  Highlight,
  InternalLink, MiniParagraph,
  Paragraph,
  Strike
} from "../style/itf-styled-components";
import React from "react";
import {useTrainers} from "../data/hooks/members";
import {Description} from "./description";


const WorkshopsList = ({workshops}) => {
  const trainers = useTrainers();

  return (
    workshops
      .map((workshop, index) => {
        const Trainer = trainers.find(trainer => trainer.roles.find(role => role.events.includes(workshop.slug)));

        return (
          <div
            css={`
            border-bottom: 1px solid ${props => props.theme.colors.neutrals._200};
            padding: 10px 0 25px;
            
            :last-child {
              border-bottom: none;
            }
          `}
            id={workshop.slug}
            key={index}
          >
            <Heading3><Highlight>{workshop.name}</Highlight></Heading3>
            <MiniParagraph>Cu:&nbsp;
              <InternalLink to={`/speakeri-traineri/${Trainer.slug}`}>
                <strong>{Trainer.name}</strong>
              </InternalLink>
            </MiniParagraph>
            {!!workshop.address && <MiniParagraph>Locație: <strong>{workshop.address}</strong></MiniParagraph>}
            {!!workshop.room && <MiniParagraph>Sala: <strong>{workshop.room}</strong></MiniParagraph>}
            {!!workshop.date && <MiniParagraph>Dată: <strong>{workshop.date}</strong></MiniParagraph>}
            {!!workshop.seats && <MiniParagraph>Locuri disponibile: <strong>{workshop.seats}</strong></MiniParagraph>}
            {!!workshop.duration && <MiniParagraph>Durata: <strong>{workshop.duration}</strong></MiniParagraph>}
            {!!workshop.earlyBird
              ? <MiniParagraph>Preț: <Strike>{workshop.price}</Strike> <strong>{workshop.earlyBird}</strong></MiniParagraph>
              : <MiniParagraph>Preț: <strong>{workshop.price}</strong></MiniParagraph>
            }
            <>
              {!!workshop.description
                ? (workshop.description).map((i, index) => (
                  <div key={`${workshop.slug}-${index}`}>
                    <Description type={i.type} value={i.value} />
                  </div>
                ))
                : <br/>
              }
            </>
            {!workshop.done && <Paragraph css={`margin-top: 15px;`}>
              <CtaWireframeButton as={InternalLink} to="/bilete">Cumpără Bilet</CtaWireframeButton>
            </Paragraph>}
          </div>
        )})
  )
}

export default WorkshopsList;